import { Navigate, RouteObject } from "react-router";
import { CommitmentRoute } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/commitment-route";
import { FulfillmentsRoute } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/fulfillments/fulfillments-route";
import { DataRoute } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/data/data-route";
import { SeriesRoute } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/series/series-route";

export const commitmentRoutes: RouteObject[] = [
  {
    path: ":commitmentId",
    element: <CommitmentRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "fulfillments",
        element: <FulfillmentsRoute />,
      },
      {
        path: "series",
        element: <SeriesRoute />,
      },
    ],
  },
];
